import { SVGProps } from 'react';

export const IconAdd = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox='0 0 20 20' fill='none'>
      <path d='M10 6V14' stroke='currentColor' strokeWidth='2' strokeLinecap='round' />
      <path d='M6 10L14 10' stroke='currentColor' strokeWidth='2' strokeLinecap='round' />
    </svg>
  );
};
